import React from "react";
import { useEffect, useState } from "react";
import { UrlApi } from "../../../../../services/apirest";
import {
  Typography,
  Dialog,
  DialogContent,
  Autocomplete,
  Grid,
  DialogTitle,
  FormControl,
  Tooltip,
  IconButton,
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import ContactsIcon from "@mui/icons-material/Contacts";
import InputAdornment from "@mui/material/InputAdornment";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import BadgeIcon from "@mui/icons-material/Badge";
import Notify from "../../../../Notify";
import Alerta from "../../../../Alerta";
import { v4 as uuidv4 } from "uuid"; ///me da un unico id para poner en los pedidos y repartos
import MapaDireccionEnv from "./MapaDireccionEnv";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import { registrarAccion, DONDE } from "../../../logs/registrarAccion";

function AltaDireccionEnv(props) {
  const size = "small";
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  const [datosDir, setDatosDir] = useState({
    id_cliente: props.cliente.id,
    id_provincia: "",
    id_localidad: "",
    id_sucursal: "",
    id_ruta: "",
    direccion_entrega: "",
    nombre_direccion: "",
    contacto: "",
    telefono_1: "",
    telefono_2: "",
    telefono_3: "",
    mails: "",
    latitud: 0,
    longitud: 0,
    usuario: localStorage.getItem("user"),
    activo: 1,
    observaciones: "",
    zona: null,
  });
  // PARA AUTOCOMPLETES
  const [buscando, setBuscando] = useState(false);
  const [provinciaSeleccionada, setProvinciaSeleccionada] = useState("");
  const [localidadSeleccionada, setLocalidadSeleccionada] = useState("");
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [zonaSeleccionada, setZonaSeleccionada] = useState("");
  const [localidades, setLocalidades] = useState(null);
  const [provincias, setProvincias] = useState(null);
  const [sucursales, setSucursales] = useState(null);
  const [uuid, setUuid] = useState("");
  const [geozonasPorDomicilio, setGeozonasPorDomicilio] = useState({});
  const [loading, setLoading] = useState(true);
  /*-----*/
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [colormensaje, setColorMensaje] = useState(""); //define el color que tendrá la notificación
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [mensajeAlerta, setMensajeAlerta] = useState(""); //mensaje que contendrá el componente "alerta"
  const [disBtn, setDisBtn] = useState(false);
  /*-----*/

  const almacenar = (e) => {
    setDatosDir({
      ...datosDir,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };

  const obtenerLocalidades = () => {
    fetch(UrlApi + "/localidades/prov/" + provinciaSeleccionada.id)
      .then((data) => data.json())
      .then((data) => setLocalidades(data))
      .then((data) => setBuscando(false));
  };

  const obtenerSuc = () => {
    fetch(UrlApi + "/sucursales") //fetch con la urp de api q esta en services/apirest + la ruta
      .then((data) => data.json()) //mando los datos que recibo en json
      .then((data) => setSucursales(data)); //seteo Sucursales
  };

  const obtenerProvincias = () => {
    fetch(UrlApi + "/provincias") //fetch con la urp de api q esta en services/apirest + la ruta
      .then((data) => data.json()) //mando los datos que recibo en json
      .then((data) => setProvincias(data)); //seteo Sucursales
  };

  const [codArg, setCodArg] = useState("");
  const getCodArg = () => {
    fetch(UrlApi + "/desplegables/codArg")
      .then((data) => data.json())
      .then((data) => setCodArg(data[0].valor));
  };

  useEffect(() => {
    obtenerProvincias();
    // obtenerProductos();
    // obtenerZonas();
    setUuid(uuidv4());
    getCodArg();
  }, []);

  useEffect(() => {
    obtenerSuc();
  }, []);

  useEffect(() => {
    obtenerLocalidades();
    datosDir.id_localidad = "";
  }, [provinciaSeleccionada]);

  async function guardarDireccion(e) {
    setDisBtn(true);
    e.preventDefault();
    const response = await fetch(UrlApi + "/envasado_direcciones_entrega", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id_cliente: props.cliente.id,
        // id_provincia: provinciaSeleccionada.id,
        id_localidad: localidadSeleccionada.id,
        id_sucursal: sucursalSeleccionada.id,
        id_ruta: datosDir.id_ruta ? datosDir.id_ruta : null,
        direccion_entrega: datosDir.direccion_entrega,
        nombre_direccion: datosDir.nombre_direccion,
        contacto: datosDir.contacto,
        telefono_1: datosDir.telefono_1 ,
        telefono_2: datosDir.telefono_2 ,
        telefono_3: datosDir.telefono_3 ,
        mails: datosDir.mails,
        latitud: datosDir.latitud,
        longitud: datosDir.longitud,
        usuario: datosDir.usuario,
        activo: datosDir.activo,
        nro_dir: uuid,
        observaciones: datosDir.observaciones,
        zona: zonaSeleccionada.id,
      }),
    });
    if (response.ok === false) {
      const error = response && response.json();
      setError(error);
      setMensajeAlerta("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      const logAlta = () =>
        registrarAccion(
          DONDE.CLIENTES,
          `Alta de dirección de entrega para cliente ${props.cliente.id}: ${datosDir.direccion_entrega} (${localidadSeleccionada.localidad})`
        );
      try {
        const json = await response.json();
        if (json.message) {
          logAlta();
          setNotificacion(true);
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje(
            json.message === "OK" ? "Guardado" : "Guardado. Actualizar rta API."
          );
          props.actualizar();
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          logAlta();
          setNotificacion(true);
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("Guardado. Actualizar RTA API A JSON");
          props.actualizar();
        }
      }
    }
  }
  useEffect(() => {
    // const isAnyPhoneComplete =
    //   datosDir.telefono_1 !== "" ||
    //   datosDir.telefono_2 !== "" ||
    //   datosDir.telefono_3 !== "";
    if (
      Object.keys(provinciaSeleccionada).length === 0 ||
      Object.keys(localidadSeleccionada).length === 0 ||
      Object.keys(sucursalSeleccionada).length === 0 ||
      // !isAnyPhoneComplete ||
      // datosDir.mails === "" ||
      datosDir.latitud === 0 ||
      datosDir.longitud === 0
    ) {
      setDisBtn(true);
    } else {
      setDisBtn(false);
    }
  }, [datosDir]);

  //  geozonas automaticas
  // Geozona automática según la localidad seleccionada
  const [zonaInicialCargada, setZonaInicialCargada] = useState(false);
  useEffect(() => {
    const fetchGeozona = async () => {
      if (!localidadSeleccionada?.id) return;

      try {
        setLoading(true);

        const res = await fetch(
          `${UrlApi}/geozonas/xlocalidad/${localidadSeleccionada.id}`
        );
        const data = await res.json();

        setGeozonasPorDomicilio({
          [uuid]: {
            nombreDireccion: datosDir.nombre_direccion || "Sin nombre",
            localidad: localidadSeleccionada.id,
            geozonas: data,
          },
        });
      } catch (err) {
        console.error("Error fetching geozona:", err);
        setError("Error al cargar la geozona");
      } finally {
        setLoading(false);
      }
    };

    fetchGeozona();
  }, [localidadSeleccionada?.id, uuid, datosDir.nombre_direccion]);

  function isPointInPolygon(point, polygon) {
    const x = point.lat;
    const y = point.lng;
    let inside = false;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].lat,
        yi = polygon[i].lng;
      const xj = polygon[j].lat,
        yj = polygon[j].lng;

      const intersect =
        yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
      if (intersect) inside = !inside;
    }

    return inside;
  }

  useEffect(() => {
    if (
      loading ||
      !geozonasPorDomicilio[uuid] ||
      !datosDir.latitud ||
      !datosDir.longitud
    ) {
      return;
    }

    console.group("[EFFECT] Verificación automática de zona");

    const domicilioGeozonas = geozonasPorDomicilio[uuid];

    const point = {
      lat: parseFloat(datosDir.latitud),
      lng: parseFloat(datosDir.longitud),
    };

    const zonaEncontrada = domicilioGeozonas.geozonas.find((zona) => {
      const esPoligonoValido =
        zona.type === "polygon" &&
        zona.coordinates &&
        zona.coordinates.length >= 3;

      if (!esPoligonoValido) {
        return false;
      }

      const estaEnPoligono = isPointInPolygon(point, zona.coordinates);
      return estaEnPoligono;
    });

    const idZonaDetectada = zonaEncontrada?.id || null;

    if (!zonaSeleccionada?.id && idZonaDetectada) {
      setZonaSeleccionada(zonaEncontrada); // actualizás objeto completo
      setDatosDir((prev) => ({ ...prev, zona: idZonaDetectada }));
    } else if (zonaSeleccionada?.id !== idZonaDetectada) {
      console.log(" Zona seleccionada distinta, se respeta selección manual");
    } else {
      console.log(" Zona ya asignada correctamente");
    }

    console.groupEnd();
  }, [
    loading,
    geozonasPorDomicilio,
    datosDir.latitud,
    datosDir.longitud,
    zonaSeleccionada?.id,
    uuid,
  ]);

  const detectarZonaPorCoordenadas = () => {
    const zonas = geozonasPorDomicilio[uuid]?.geozonas;
    const lat = parseFloat(datosDir.latitud);
    const lng = parseFloat(datosDir.longitud);

    if (!zonas || !lat || !lng) {
      console.warn("Faltan datos para detectar la zona");
      return;
    }

    const puntoActual = { lat, lng };

    const zonaCoincidente = zonas.find(
      (zona) =>
        zona.type === "polygon" &&
        zona.coordinates?.length >= 3 &&
        isPointInPolygon(puntoActual, zona.coordinates)
    );

    if (zonaCoincidente) {
      setZonaSeleccionada(zonaCoincidente);
    } else {
      console.warn("No se encontró zona para estas coordenadas.");
      // Opcional: podés setear null o mostrar un snackbar
    }
  };

  return (
    <div>
      {notificacion ? (
        <Notify
          mensaje={mensaje}
          open={openSnack}
          color={colormensaje}
          handleClose={() => {
            props.setOpen(false);
            props.onClose();
          }}
          severity={"success"}
        />
      ) : null}
      {error && mensajeAlerta ? (
        <Alerta mensaje={mensajeAlerta} severity={"error"} />
      ) : null}
      <Dialog
        maxWidth="xl"
        open={props.open}
        onClose={() => {
          props.setOpen(false);
          // props.onClose();
        }}
        style={{ zIndex: 1 }}
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography variant="h6" align="center" color="#ffffff">
              Nueva Dirección De Entrega ({props.cliente.razon_social})
            </Typography>
          </DialogTitle>
        </Box>
        <DialogContent>
          <form>
            <Grid
              container
              spacing={1}
              direction="row"
              justify="flex-start"
              alignItems="flex-start"
            >
              <Grid container xs={7}>
                <Grid container direction="row" spacing={1.5}>
                  <Grid item xs={12} mt={1}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Ejemplo: Casa Central"
                      type="text"
                      required
                      focused
                      name="nombre_direccion"
                      label="Lugar de entrega"
                      color="primary"
                      onChange={almacenar}
                      value={datosDir.nombre_direccion}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <BadgeIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Autocomplete
                      disabled={!provincias}
                      required
                      disableClearable
                      id="provincia"
                      style={style}
                      size={size}
                      noOptionsText={"Provincia INEXISTENTE"}
                      options={provincias}
                      autoHighlight
                      getOptionLabel={(provincia) =>
                        provincia.id + "-" + provincia.provincia
                      }
                      onChange={(event, value) => {
                        setProvinciaSeleccionada(value);
                        setBuscando(true);
                      }}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          key={option.id}
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {option.id} - {option.provincia}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          placeholder="Tipee para buscar..."
                          {...params}
                          label="Provincia"
                          focused
                          required
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    {buscando === true ? (
                      <TextField
                        disabled
                        focused
                        fullWidth
                        size={size}
                        label="Buscando Localidades..."
                      />
                    ) : (
                      <Autocomplete
                        disabled={!localidades}
                        required
                        disableClearable
                        id="localidad"
                        name="id_localidad"
                        style={style}
                        size={size}
                        noOptionsText={"Localidad INEXISTENTE"}
                        options={localidades}
                        autoHighlight
                        // getOptionLabel={(localidad) =>
                        //   localidad.id + "-" + localidad.localidad
                        // }
                        getOptionLabel={(localidad) =>
                          localidad.cp + " - " + localidad.localidad  // Cambiado: muestra CP en lugar de ID
                        }
                        onChange={(event, value) => {
                          setLocalidadSeleccionada(value);
                        }}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            key={option.id}
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {/* {option.id} - {option.localidad} */}
                            {option.cp} - {option.localidad} 
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            placeholder="Tipee para buscar..."
                            {...params}
                            label="Localidad"
                            focused
                            required
                            inputProps={{
                              ...params.inputProps,
                            }}
                          />
                        )}
                      />
                    )}
                  </Grid>
                  <Grid item xs={4}>
                    <Autocomplete
                      disabled={!sucursales}
                      required
                      disableClearable
                      id="sucursal"
                      style={style}
                      size={size}
                      noOptionsText={"Sucursal INEXISTENTE"}
                      options={sucursales}
                      autoHighlight
                      getOptionLabel={(sucursal) =>
                        sucursal.id + "-" + sucursal.nombre
                      }
                      onChange={(event, value) => {
                        setSucursalSeleccionada(value);
                      }}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          key={option.id}
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {option.id} - {option.nombre}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          placeholder="Tipee para buscar..."
                          {...params}
                          label="Sucursal"
                          focused
                          required
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Direccion de entrega"
                      type="text"
                      required
                      focused
                      name="direccion_entrega"
                      id="direccion_entrega"
                      label="Direccion de entrega"
                      color="primary"
                      onChange={almacenar}
                      value={
                        datosDir.direccion_entrega &&
                        datosDir.direccion_entrega.replace(/\b\w/g, (l) =>
                          l.toUpperCase()
                        )
                      }
                      inputProps={{ maxLength: 200 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationOnIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Sr .. "
                      type="text"
                      focused
                      name="contacto"
                      label="Contacto"
                      color="primary"
                      onChange={almacenar}
                      value={datosDir.contacto}
                      inputProps={{ maxLength: 200 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <ContactsIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="ejemplo@mail.com"
                      type="email"
                      focused
                      name="mails"
                      id="mails"
                      label="Mails"
                      color="primary"
                      onChange={almacenar}
                      value={datosDir.mails}
                      inputProps={{ maxLength: 300 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <ContactMailIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      size="small"
                      fullWidth
                      focused
                      name="telefono_1"
                      label="Telefono 1"
                      color="primary"
                      onChange={almacenar}
                      value={datosDir.telefono_1}
                      inputProps={{
                        maxLength: 10,
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {codArg}
                          </InputAdornment>
                        ),
                      }}
                      // helperText="Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      size="small"
                      fullWidth
                      focused
                      name="telefono_2"
                      label="Telefono 2"
                      color="primary"
                      onChange={almacenar}
                      value={datosDir.telefono_2}
                      inputProps={{
                        maxLength: 10,
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {codArg}
                          </InputAdornment>
                        ),
                      }}
                      // helperText="Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      size="small"
                      fullWidth
                      focused
                      name="telefono_3"
                      label="Telefono 3"
                      color="primary"
                      onChange={almacenar}
                      value={datosDir.telefono_3}
                      inputProps={{
                        maxLength: 10,
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {codArg}
                          </InputAdornment>
                        ),
                      }}
                      // helperText="Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      size="small"
                      fullWidth
                      focused
                      name="latitud"
                      label="Latitud"
                      color="primary"
                      value={datosDir.latitud}
                      inputProps={{ maxLength: 300 }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      size="small"
                      fullWidth
                      focused
                      name="longitud"
                      label="Longitud"
                      color="primary"
                      value={datosDir.longitud}
                      inputProps={{ maxLength: 300 }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      focused
                      variant="outlined"
                      inputProps={{
                        maxLength: 200,
                      }}
                      fullWidth
                      size={size}
                      label="Observaciones"
                      value={datosDir.observaciones}
                      name="observaciones"
                      onChange={almacenar}
                    />
                  </Grid>
                  <Grid item xs={11}>
                    {geozonasPorDomicilio && (
                      <Autocomplete
                        disabled={
                          !geozonasPorDomicilio[uuid]
                        }
                        options={
                          geozonasPorDomicilio[uuid]
                            ?.geozonas || []
                        }
                        getOptionLabel={(zona) =>
                          zona
                            ? `${zona.nombre}${
                                zona.descripcion ? ` - ${zona.descripcion}` : ""
                              }`
                            : "Ninguna"
                        }
                        value={zonaSeleccionada}
                        onChange={(_, newValue) => {
                          setZonaSeleccionada(newValue);
                          setZonaInicialCargada(true);
                        }}
                        disableClearable
                        renderInput={(params) => {
                          const hasCoords =
                            datosDir.latitud && datosDir.longitud;
                          const currentZone = geozonasPorDomicilio[
                            uuid
                          ]?.geozonas?.find(
                            (z) => z.id === zonaSeleccionada?.id
                          );

                          const isValidZone =
                            hasCoords &&
                            currentZone &&
                            isPointInPolygon(
                              {
                                lat: parseFloat(datosDir.latitud),
                                lng: parseFloat(datosDir.longitud),
                              },
                              currentZone.coordinates
                            );

                          return (
                            <TextField
                              {...params}
                              label="Zona"
                              size="small"
                              focused
                              helperText={
                                !hasCoords
                                  ? "Ingrese coordenadas para verificar zona"
                                  : isValidZone
                                  ? "Zona válida para estas coordenadas"
                                  : zonaSeleccionada
                                  ? "⚠️ Zona no coincide con coordenadas"
                                  : "Seleccione una zona manualmente"
                              }
                              error={
                                hasCoords && zonaSeleccionada && !isValidZone
                              }
                            />
                          );
                        }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={1}>
                    <FormControl fullWidth>
                      <Tooltip
                        placement="bottom"
                        title="Asignar Zona Automaticamente"
                      >
                        <IconButton
                          aria-label="Detectar zona automáticamente"
                          onClick={detectarZonaPorCoordenadas}
                          size="small"
                          color="primary"
                        >
                          <GpsFixedIcon />
                        </IconButton>
                      </Tooltip>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container xs={5}>
                {/* ACA VA EL MAPA  */}
                <Grid container size={"grow"} direction="column" ml={1}>
                  <MapaDireccionEnv
                    setDatosDir={setDatosDir}
                    datosDir={datosDir}
                    height="200px"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid
              mt={1}
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Button
                // disabled={disBtn}
                size="small"
                variant="outlined"
                onClick={() => {
                  props.setOpen(false);
                  // props.setOpen();
                }}
                color="error"
              >
                Volver
              </Button>
              <Button
                disabled={disBtn}
                variant="contained"
                onClick={guardarDireccion}
                color="success"
                size="small"
              >
                Guardar Direccion
              </Button>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default AltaDireccionEnv;
